export const PLACEHOLDER_IMAGE_URL = new URL(
  '~shared-assets/images/product-placeholder.svg',
  import.meta.url
).toString();
